import {formatMoney} from '@shopify/theme-currency';
import $ from 'jquery';
import CustomEvent from 'custom-event';

const events = {
  updated: 'wishlist:updated',
};

/**
 * @param {jQuery} node
 */
function getJson(node) {
  if (!node.length) {
    return {};
  }

  try {
    const data = node.html();

    return JSON.parse(data);
  } catch (exception) {
    return {};
  }
}

/**
 * @param {jQuery} product
 */
function getDataSource(product) {
  const jsonElement = product.find('[data-wishlist-json]');

  if (jsonElement.length) {
    return getJson(jsonElement);
  }

  return product.data();
}

/**
 * @param {jQuery} product
 * @returns {Object}
 */
export function getWishlistItemData(product) {
  const source = getDataSource(product);
  const {
    productId,
    purchasable,
    price,
    image,
    url,
    title,
    link,
    selectedVariant,
    variants,
  } = source;

  if (!productId) {
    return {};
  }

  const variantId = product.attr('data-variant-id');
  const formattedPrice = String(price).replace(',', '.');

  return {
    empi: productId,
    epi: variantId ? variantId : selectedVariant,
    pr: formattedPrice,
    iu: image,
    du: url,
    pt: title,
    cprops: {
      link: link ? link : url,
      purchasable,
      title,
    },
    variants,
  };
}

/**
 * @param {Array} arr
 * @returns {Object}
 */
export function arrayToProperties(arr) {
  return arr.reduce((accu, curr) => {
    return {
      ...accu,
      [curr.name]: curr.value,
    };
  }, {});
}

/**
 * @param {Object} product
 * @returns {Boolean}
 */
export function isInCart(product) {
  return (
    window._swat.platform.isInDeviceCart(product.epi) ||
    product.et === window._swat.EventTypes.addToCart
  );
}

/**
 * @param {Object} product
 * @returns {Object}
 */
export function formatProduct(product) {
  return {
    ...product,
    price: product.pr,
    formattedPrice: formatMoney(
      Number(product.pr).toFixed(2),
      theme.moneyFormat,
    ),
    isInCart: isInCart(product),
    variants: product.variants ? JSON.parse(product.variants) : null,
    hasVariants: product.variants ? product.variants.length : false,
  };
}

/**
 * @param {Object[]} products
 * @returns {Promise}
 */
export function getProductDetails(products) {
  const requestObjects = products.map(item => {
    const {du, empi, epi} = item;

    return {
      du,
      empi,
      epi,
    };
  });

  const productRequests = requestObjects
    .filter(req => req.du)
    .map(request => $.getJSON(`${request.du}.js`));

  return Promise.all(productRequests);
}

/**
 * @param {Object[]} products
 * @param {Object} item
 * @returns {JQuery}
 */
export function isInWishlist(products, item) {
  return products.find(
    prod =>
      Number(prod.empi) === Number(item.empi) &&
      Number(prod.epi) === Number(item.epi),
  );
}

/**
 * @param {jQuery} target
 */
export function dispatchWishlistUpdate(target) {
  const event = new CustomEvent(events.updated, {
    bubbles: true,
  });

  target.get(0).dispatchEvent(event);
}
